import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { flag, STATUS_STYLE } from "@/lib/helpers";

export function Logo({ light = false, size = "md" }) {
  const big = size === "lg";
  if (big) {
    return (
      <Link to="/" data-testid="wei-logo" className="inline-flex select-none">
        <img src="/brand/wei-logo-full-sm.png" alt="WEI — World Entertainment Institute. Building the World's Entertainment Record" className="h-28 sm:h-32 w-auto rounded-sm" data-testid="wei-logo-image" />
      </Link>
    );
  }
  return (
    <Link to="/" data-testid="wei-logo" className="inline-flex items-center gap-2.5 leading-none select-none">
      <img src="/brand/wei-crest-256.png" alt="WEI lion crest" className="h-11 w-11 object-cover rounded-full ring-1 ring-gold/40" data-testid="wei-logo-crest" />
      <span className="inline-flex flex-col">
        <span className="font-serif font-bold gold-text tracking-tight text-[30px]">WEI</span>
        <span className={`eyebrow !tracking-[0.22em] whitespace-nowrap text-[7.5px] sm:text-[8.5px] -mt-0.5 ${light ? "text-white/80" : "text-charcoal"}`}>World Entertainment Institute</span>
      </span>
    </Link>
  );
}

export function VerifiedBadge({ status, compact = false }) {
  const verified = ["identity_verified", "professionally_verified", "institutionally_endorsed", "historical"].includes(status);
  if (compact) return verified ? <ShieldCheck data-testid="verified-icon" className="w-4 h-4 text-gold inline-block" strokeWidth={2.2} /> : null;
  const label = { historical: "HISTORICAL PROFILE", claimed: "CLAIMED", listed: "LISTED" }[status] || (verified ? "WEI VERIFIED" : "LISTED");
  return (
    <span data-testid="verified-badge" className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-sm text-[11px] font-bold tracking-[0.14em] ${STATUS_STYLE[status] || STATUS_STYLE.listed}`}>
      <ShieldCheck className="w-3.5 h-3.5" strokeWidth={2.4} /> {label}
    </span>
  );
}

export function Flag({ code, name, className = "" }) {
  return <span className={`inline-flex items-center gap-1.5 text-xs text-charcoal ${className}`}><span aria-hidden>{flag(code)}</span>{name}</span>;
}

export function CategoryLabel({ children, light }) {
  return <span className={`label-bordeaux ${light ? "!text-gold-light" : ""}`}>{children}</span>;
}

export function Movement({ value }) {
  if (!value) return <span data-testid="movement" className="text-[#8A867E] text-xs font-medium">— 0</span>;
  const up = value > 0;
  return <span data-testid="movement" className={`text-xs font-semibold ${up ? "text-emerald-700" : "text-bordeaux"}`}>{up ? "▲" : "▼"} {Math.abs(value)}</span>;
}

export function DemoTag() {
  return <span data-testid="demo-tag" className="text-[9px] uppercase tracking-[0.18em] font-semibold text-[#8A867E] border border-[#D9D5CC] px-1.5 py-0.5 rounded-sm">Demo data</span>;
}
